import { Component } from '@angular/core';
import { OpenIdService } from './service/open-id.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
})
export class AppComponent {
    title = 'www';
    constructor(private openIdService: OpenIdService) {
        console.log('AppComponent');
        this.openIdService.init();
    }
}
